import { connect } from 'react-redux'
import { Map } from 'immutable'

import { updateUserPhoneNumber } from 'store/entities/organizations/actions'
import { parsePhoneBeforeShow, parsePhoneBeforeSend } from 'helpers/parsePhone'
import { USA_ISO, ISO_CODE } from 'app/constants/phoneCountryCodes'
import PhoneForm from './PhoneForm'

export const createPhoneFormName = userId => `phoneForm_${userId}`

const mapStateToProps = (state, { phoneWithoutCode, userId, phoneISO }) => ({
  initialValues: Map({
    phone: (phoneWithoutCode && parsePhoneBeforeShow(phoneWithoutCode, phoneISO)) || '',
    phoneISO: phoneISO || USA_ISO,
  }),
  form: createPhoneFormName(userId),
  phoneWithoutCode,
})

const mapDispatchToProps = (dispatch, { userId }) => ({
  onRemove: () => dispatch(updateUserPhoneNumber({ id: userId, phone: '', phoneISO: USA_ISO })),
  onSubmit: (data, dispatch) => {
    const phoneWithoutCode = data.get('phone')
    const phoneISO = data.get('phoneISO')
    dispatch(
      updateUserPhoneNumber({
        id: userId,
        phone: phoneWithoutCode && parsePhoneBeforeSend(`${ISO_CODE[phoneISO]}${phoneWithoutCode}`),
        phoneISO,
      })
    )
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(PhoneForm)
